










import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class SubmitButton extends Vue {
  @Prop() disabled!: boolean;
}
